import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

export default function InitiativeCard({ item, index = 0, compact = false }) {
  const { t } = useTranslation();
  const stat = item.stats?.[0];
  return (
    <Link
      to={`/initiatives/${item.slug}`}
      data-testid={`initiative-card-${item.slug}`}
      className={`group bg-white border border-ink/10 card-hover flex flex-col rise-in rise-in-${(index % 4) + 1} ${compact ? "p-6" : "p-7"}`}
    >
      <div className="flex items-center justify-between mb-5">
        <span className="tag">{t(`initiative.categories.${item.category}`)}</span>
        <span className="font-mono text-[10px] text-ink/50">{String(index + 1).padStart(2, "0")}</span>
      </div>
      <h3 className="font-display font-bold text-brand text-lg leading-snug">{item.title}</h3>
      <p className="mt-2 text-ink/70 text-sm leading-relaxed flex-1">{item.short}</p>
      {stat && !compact && (
        <div className="mt-5 pt-4 border-t border-ink/10">
          <div className="font-display font-black text-teal text-xl leading-none">{stat.value}</div>
          <div className="mt-1 font-mono text-[10px] uppercase tracking-widest text-ink/60">{stat.label}</div>
        </div>
      )}
      <div className="mt-4 inline-flex items-center gap-1 text-teal font-medium text-sm">
        {t("home.learn_more")} <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
      </div>
    </Link>
  );
}
